document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll(".logo-strip-swiper");

  sliders.forEach((slider) => {
    new Swiper(slider, {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 20,
      slidesPerGroup: 2,
      navigation: {
        nextEl: slider.querySelector(".swiper-button-next"),
        prevEl: slider.querySelector(".swiper-button-prev"),
      },

      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        clickable: true,
      },

      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },

      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
          slidesPerGroup: 4
        },
      },
    });
  });
});
